import React from "react";

export const Card = ({ title, subtitle, action, children, className = "", testId }) => (
  <section className={`card-surface p-5 sm:p-6 rise ${className}`} data-testid={testId}>
    {(title || action) && (
      <header className="flex items-start justify-between gap-3 mb-4">
        <div>
          {title && (
            <h3 className="font-display text-lg sm:text-xl font-semibold tracking-tight">
              {title}
            </h3>
          )}
          {subtitle && (
            <p className="text-xs text-muted-foreground mt-0.5">{subtitle}</p>
          )}
        </div>
        {action}
      </header>
    )}
    {children}
  </section>
);
